var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhMinimalWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.455,
    height: 30,
    viewBox: "0 0 52.455 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M1430.917,103.277l-9.055,12.886h0q-.165.235-.346.459a8.556,8.556,0,0,1-12.325,1.024c-.542-.481-1.041-1.019-1.552-1.531l-1.393-1.393-1.392,1.393c-.512.512-1.01,1.05-1.552,1.531a8.552,8.552,0,0,1-12.325-1.024q-.18-.223-.346-.459l-9.055-12.886A8.55,8.55,0,0,1,1394.605,92.3l2.8,2.8,2.03-2.032.751-.752a8.555,8.555,0,0,1,11.63-.46c.337.289.645.611.958.925l2.316,2.319,2.8-2.8a8.55,8.55,0,0,1,13.028,10.978",
    transform: "translate(-1380.02 -89.795)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhMinimalWhite);
export default __webpack_public_path__ + "static/media/WH-minimal-white.b24597764162946c142c7c0deb73e8c7.svg";
export { ForwardRef as ReactComponent };